/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetHourlyRateRequest
 */
export interface SetHourlyRateRequest {
  /**
   *
   * @type {string}
   * @memberof SetHourlyRateRequest
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof SetHourlyRateRequest
   */
  hourlyRate: string;
  /**
   *
   * @type {string}
   * @memberof SetHourlyRateRequest
   */
  regularWeeklyExtraHours: string;
}

/**
 * Check if a given object implements the SetHourlyRateRequest interface.
 */
export function instanceOfSetHourlyRateRequest(
  value: object,
): value is SetHourlyRateRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("hourlyRate" in value) || value["hourlyRate"] === undefined)
    return false;
  if (
    !("regularWeeklyExtraHours" in value) ||
    value["regularWeeklyExtraHours"] === undefined
  )
    return false;
  return true;
}

export function SetHourlyRateRequestFromJSON(json: any): SetHourlyRateRequest {
  return SetHourlyRateRequestFromJSONTyped(json, false);
}

export function SetHourlyRateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetHourlyRateRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    hourlyRate: json["hourlyRate"],
    regularWeeklyExtraHours: json["regularWeeklyExtraHours"],
  };
}

export function SetHourlyRateRequestToJSON(json: any): SetHourlyRateRequest {
  return SetHourlyRateRequestToJSONTyped(json, false);
}

export function SetHourlyRateRequestToJSONTyped(
  value?: SetHourlyRateRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    hourlyRate: value["hourlyRate"],
    regularWeeklyExtraHours: value["regularWeeklyExtraHours"],
  };
}
